import EditableField from '../EditableField';
import ImagePreview from '../../ImagePreview';
import { Card } from '../../ui/card';
import { BankAttachmentUpload } from '../BankAttachmentUpload';

const CardsTab = ({ editData, updateField, canEdit, editingField, editingValue, setEditingValue, startEditing, confirmEdit, cancelEdit }) => {
  const editProps = { canEdit, editingField, editingValue, setEditingValue, startEditing, confirmEdit, cancelEdit };
  const debitCards = editData.debitCards || [];

  return (
    <div className="space-y-3">
      <Card className="p-2 divide-y">
        <div className="px-3 py-2"><h3 className="font-semibold text-sm text-slate-700">Primary Debit Card</h3></div>
        <EditableField field="debitCardNumber" label="Card Number" value={editData.debitCardNumber} {...editProps} />
        <EditableField field="debitCardExpiry" label="Expiry (MM/YY)" value={editData.debitCardExpiry} {...editProps} />
        <EditableField field="debitCardCVV" label="CVV" value={editData.debitCardCVV} {...editProps} />
        <EditableField field="debitCardPIN" label="PIN" value={editData.debitCardPIN} {...editProps} />
        <div className="px-3 py-2">
          <span className="text-xs text-slate-500">Card Image</span>
          <div className="mt-1"><ImagePreview imageUrl={editData.debitCardImageDataUrl} label="Debit Card" /></div>
          {canEdit && <BankAttachmentUpload field="debitCard" className="mt-2" data-testid="cards-debit-upload" />}
        </div>
      </Card>

      {debitCards.length > 1 && debitCards.slice(1).map((card, idx) => (
        <Card key={`extra-card-${idx}`} className="p-2 divide-y">
          <div className="px-3 py-2"><h3 className="font-semibold text-sm text-slate-700">Debit Card {idx + 2}</h3></div>
          <div className="px-3 py-2 flex justify-between items-center">
            <span className="text-xs text-slate-500">Card Number</span>
            <span className="text-sm font-mono">{card.cardNumber || '-'}</span>
          </div>
          <div className="px-3 py-2 flex justify-between items-center">
            <span className="text-xs text-slate-500">Expiry</span>
            <span className="text-sm">{card.expiry || '-'}</span>
          </div>
          <div className="px-3 py-2 flex justify-between items-center">
            <span className="text-xs text-slate-500">CVV</span>
            <span className="text-sm">{card.cvv || '-'}</span>
          </div>
          <div className="px-3 py-2 flex justify-between items-center">
            <span className="text-xs text-slate-500">PIN</span>
            <span className="text-sm">{card.pin || '-'}</span>
          </div>
          {card.imageDataUrl && (
            <div className="px-3 py-2">
              <span className="text-xs text-slate-500">Card Image</span>
              <div className="mt-1"><ImagePreview imageUrl={card.imageDataUrl} label={`Card ${idx + 2}`} /></div>
            </div>
          )}
        </Card>
      ))}
    </div>
  );
};

export default CardsTab;
